<template>
<v-container fluid>
  <h2 class="d-flex justify-space-between">Product Sales Performance (since 2022)</h2>
  <div class="d-flex">
    <v-spacer />
    <v-btn
      class="ma-2"
      color="primary"
      @click="downloadExcel"
    >
      <v-icon>mdi-table</v-icon>
    </v-btn>
  </div>
  <select-artist :useActiveArtist="false" @onChange="handleArtistChange"></select-artist>
  <v-data-table
    :headers="headers"
    :items="products"
    :disable-pagination="true"
    :hide-default-footer=true
    :loading="loading"
    loading-text="Crunching data ... Please wait"
    class="elevation-1"
  >
    <template v-slot:[`item.image`]="{ item }">
      <v-img class="my-2" max-height="150px" max-width="150px"
          :src="`${imageUrl}/300px/${item.image}`"
        ></v-img>
    </template>
    <template v-slot:[`item.value`]="{ item }">
      <span>£{{item.value.toFixed(2)}}</span>
    </template>
  </v-data-table>
</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ReportApi from '@/api/admin/report'
import xlsx from 'xlsx'
import SelectArtist from '@/components/SelectArtist'

export default {
  components: {
    SelectArtist
  },
  data () {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      products: [],
      loading: false,
      artist: null,
      // filteredArtworks: [],
      headers: [
        {
          text: 'Image',
          sortable: false,
          value: 'image'
        },
        {
          text: 'Sku',
          sortable: true,
          value: 'sku'
        },
        {
          text: 'Product',
          sortable: true,
          value: 'productVariant'
        },
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Status',
          value: 'productStatus'
        },
        {
          text: 'Total Revenue',
          align: 'end',
          value: 'value'
        },
        {
          text: 'Total',
          width: '8%',
          align: 'end',
          value: 'count'
        },
      ]
    }
  },
  methods: {
    async getSales (artistCode) {
      this.loading = true
      ReportApi.loadArtistUnsoldProducts(artistCode).then((results) => {
        this.products = results.data
        this.loading = false
      })
    },
    downloadExcel () {
      const headers = [
          'sku',
          'productVariant',
          'title',
          'productStatus',
          'value',
          'count'
      ]
      const workbook = xlsx.utils.book_new()
      const worksheet = xlsx.utils.json_to_sheet(this.products, { header: headers })
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Sales')
      xlsx.writeFile(workbook, `${this.artist}-PRODUCT-PERFORMANCE.xlsx`)
    },
    async handleArtistChange (evt) {
      this.artist = evt.name
      await this.getSales(evt.artistCode)
    },
  },
  computed: {
    },
  async mounted () {
  }
}
</script>
